import React from "react";
import { LayoutDashboard } from "lucide-react";
import type { BrandingConfig } from "../../config/branding";

interface AuthBrandLogoProps {
  branding: BrandingConfig;
  size?: "hero" | "modal";
}

const sizeClasses = {
  hero: "h-20 md:h-24 max-w-[340px]",
  modal: "h-14 max-w-[240px]",
};

export function AuthBrandLogo({ branding, size = "modal" }: AuthBrandLogoProps) {
  if (branding.logoSrc && branding.logoDisplay === "full") {
    return (
      <img
        src={branding.logoSrc}
        alt={branding.logoAlt}
        className={`${sizeClasses[size]} w-auto object-contain select-none drop-shadow-[0_8px_20px_rgba(15,23,42,0.16)] dark:brightness-[2.2] dark:contrast-[0.72] dark:drop-shadow-[0_10px_24px_rgba(255,255,255,0.10)]`}
      />
    );
  }

  if (branding.logoSrc) {
    return (
      <img
        src={branding.logoSrc}
        alt={branding.logoAlt}
        className="h-10 w-auto object-contain select-none"
      />
    );
  }

  return (
    <div className="inline-flex p-2.5 rounded-xl bg-gray-100/80 dark:bg-white/10">
      <LayoutDashboard size={22} strokeWidth={1.8} aria-label={branding.logoAlt} />
    </div>
  );
}
